<ion-item lines='none'>
  <ion-button tabIndex="1" class="ion-margin-right-0" slot="end" color="secondary" fill="clear" (click)="clear()"
    [disabled]="!formControl.value">
    Clear
    <ion-icon slot="end" name="close-circle-outline" class="ion-font-xlg"></ion-icon>
  </ion-button>
</ion-item>

<ion-radio-group [formControl]="$any(formControl)" [taFormlyAttributes]="field">
  @for (option of $any(props.options); track option; let index = $index) {
  <ion-item lines="none" (click)="$any(formControl).setValue(option.key)"
    [ngClass]="$any(formControl).value === option.key && index === 0 ? 'bg-tick' : $any(formControl).value === option.key && index === 1 ? 'bg-cross' : $any(formControl).value === option.key && index === 2 ? 'bg-neutral' : ''">
    <ion-label>{{ option.value }}</ion-label>
    <ion-icon slot="end" [name]="$any(formControl).value === option.key ? icons[index].checked : icons[index].unchecked"
      [color]="index === 0 ? 'success' : index === 1 ? 'danger' : 'primary'">
    </ion-icon>
  </ion-item>
  }
</ion-radio-group>